// removed by extract-text-webpack-plugin
module.exports = {"header":"CwPod-header","headerText":"CwPod-headerText","ghostTitle":"CwPod-ghostTitle","nested":"CwPod-nested"};


//////////////////
// WEBPACK FOOTER
// ./src/components/cwpod/CwPod.scss
// module id = 377
// module chunks = 0